// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function MapTrifoldBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M28.922 5.817a1.5 1.5 0 0 0-1.286-.272L20.175 7.41l-7.5-3.75a1.5 1.5 0 0 0-1.035-.114l-8 2A1.5 1.5 0 0 0 2.5 7v18a1.5 1.5 0 0 0 1.864 1.455l7.461-1.865 7.5 3.75c.32.16.688.2 1.035.114l8-2A1.5 1.5 0 0 0 29.5 25V7a1.5 1.5 0 0 0-.578-1.183ZM13.5 7.428l5 2.5v14.646l-5-2.5V7.427Zm-8 .75 5-1.25V21.83l-5 1.25V8.177Zm21 15.652-5 1.25V10.17l5-1.25V23.83Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
